import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import radioFill from './images/radio-fill.svg';
import radioEmpty from './images/radio-empty.svg';
import './SelectList.scss';

const SelectList = ({options, onClick, hideRadioButtons = false, renderItem, defaultValue}) => {
  const getDefaultIndex = () => {
    if (defaultValue !== undefined && options) {
      const index = options.findIndex((option) => option.value === defaultValue);
      return index >= 0 ? index : null;
    }
    return null;
  };

  const [selectedIndex, setSelectedIndex] = useState(() => getDefaultIndex());

  useEffect(() => {
    const newDefaultIndex = getDefaultIndex();
    
    // Update the selected index whenever defaultValue changes
    if (newDefaultIndex !== null) {
      setSelectedIndex(newDefaultIndex);
    }
  }, [options, defaultValue]);  const handleOnClick = index => option => {
    setSelectedIndex(index);
    if (onClick) onClick(option.value);
  };

  return (
    <div className='select-list'>
      {options?.map((option, index) => {
        const isSelected = selectedIndex === index;
        const labelContent = renderItem ? (
          renderItem({option, index, isSelected})
        ) : (
          <>
            {option.key}
            {option.keyText && <div className='key-text'>{option.keyText}</div>}
          </>
        );

        return (
          <div className={`${isSelected ? 'active' : ''} select-list-item`} onClick={() => handleOnClick(index)(option)} key={option.key}>
            {!hideRadioButtons && option.key !== null && <Image src={isSelected ? radioFill : radioEmpty} alt='radio-button' />}
            <div className={`select-list-item-label bold ${option.keyText ? 'has-key-text' : ''}`}>{labelContent}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SelectList;
